import React from 'react';
import classNames from 'classnames';
import { Button } from 'primereact/button';
import style from './ButtonSeplag.module.css';

const ButtonSeplag = ({
    label = '',
    icon = 'pi pi-check',
    iconPos = 'left',
    theme = 'Rounded',
    tipo = 'primary',
    type = 'button',
    disabled = false,
    onClick = () => {},
    ...props
}) => {
    return (
        <Button
            {...props}
            label={label}
            icon={icon}
            iconPos={iconPos}
            disabled={disabled}
            type={type}
            className={classNames(
                {
                    'p-button-rounded': theme === 'Rounded',
                    [`p-button-raised p-button-text ${[style.Raised]}`]: theme === 'Raised',
                    'p-button-success ': tipo === 'success',
                    'p-button-secondary ': tipo === 'secondary',
                    'p-button-info': tipo === 'info',
                    'p-button-warning': tipo === 'warning',
                    'p-button-help': tipo === 'help',
                    'p-button-danger': tipo === 'danger',
                    'p-button-plain': tipo === 'plain',
                },
                props.className
            )}
            onClick={onClick}
        />
    );
};

export default ButtonSeplag;
